/**
 * Componente que exibe o progresso do round atual
 * Formato: "2/25" ou "Round 2 de 25"
 *
 * @param {Object} props
 * @param {number} props.current - Round atual (1-25)
 * @param {number} props.total - Total de rounds (25)
 */
export default function RoundProgress({ current, total }) {
  if (!current || !total) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: '20px',
        right: '20px',
        zIndex: 10,
        fontSize: '24px',
        fontWeight: 500,
        color: 'white',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
      }}
    >
      {current}/{total}
    </div>
  );
}

